import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class BondsWithoutMaturityDateReportCriteria extends ValueObject 
{

}